<template>
    <div class="board" v-if="formData && displayData">
        <div class="bar">
            <b-icon icon="box-seam" class="icon"></b-icon>
            <span>ข้อมูลสินค้าเคลม</span>
            <b-icon icon="chevron-down" class="collapse" @click="mixinsBoard_collapseContent(true)" v-if="!mixinsBoard_isShowContent"></b-icon>
            <b-icon icon="chevron-up" class="collapse" @click="mixinsBoard_collapseContent(false)" v-if="mixinsBoard_isShowContent"></b-icon>
        </div>

        <div class="content" v-show="mixinsBoard_isShowContent">
            <perfect-scrollbar>
                <table>
                    <thead>
                        <tr>
                            <th>สินค้าที่ซื้อไป</th>
                            <th class="text-center" v-if="displayData.return.dot">สัปดาห์ยาง</th>
                            <th class="text-right">ราคาซื้อ</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <span class="text-nowrap" v-if="displayData.return.sku">SKU: {{ displayData.return.sku }}</span>
                                {{ displayData.return.productName }}
                            </td>
                            <td class="column-small text-center" v-if="displayData.return.dot">{{ displayData.return.dot }}</td>
                            <td class="column-small text-right">{{ appHelper.getCommaNumber(displayData.return.purchasePrice) }}</td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <perfect-scrollbar class="mt-4 perfect-scrollbar-with-dropdown">
                <table>
                    <thead>
                        <tr>
                            <th>สินค้าที่เปลี่ยนให้</th>
                            <th class="text-center">สัปดาห์ยาง</th>
                            <th class="text-right">ราคาขาย</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                <span class="text-nowrap" v-if="displayData.replace.sku">SKU: {{ displayData.replace.sku }}</span>
                                {{ displayData.replace.productName }}
                            </td>
                            <td class="column-small">
                                <template v-if="displayData.replace.productCategory === $Constants.CATEGORY_TIRE && selectedDot">
                                    <dropdown
                                        v-model="selectedDot.value"
                                        placeholder="สัปดาห์ยาง"
                                        :options="optionDot"
                                        :disabled="jobState === $Constants.JOB_STATUS_PENDING"
                                        :classes="{ input: ['input-field', (errorData.product.dot.blank ? 'invalid' : '')] }"
                                        @change="changeSelectedDot($event)"
                                    ></dropdown>
                                    <input-dot
                                        v-model="formData.product.replace.dot"
                                        v-show="selectedDot.value === '-'"
                                        class="input-component"
                                        :inputClass="[ 'mt-1', 'input-field', errorData.product.dot.blank ? 'invalid' : '' ]"
                                        :readonly="jobState === $Constants.JOB_STATUS_PENDING"
                                        placeholder="สัปดาห์ยาง">
                                    </input-dot>
                                    <div class="input-error-message" v-if="errorData.product.dot.blank">โปรดเลือกสัปดาห์ยาง</div>
                                </template>
                                <div v-else class="text-center text-secondary">ไม่ต้องระบุ</div>
                            </td>
                            <td class="column-small">
                                <div :class="{ 'input-block': isClaimSameProduct }">
                                    <div class="input-price">
                                        <input type="tel"
                                            v-if="isClaimSameProduct"
                                            value="-"
                                            class="input-field text-right"
                                            readonly />
                                        <input type="tel"
                                            v-show="!isClaimSameProduct"
                                            v-model="formData.product.replace.price"
                                            class="input-field text-right"
                                            :class="{ 'invalid': errorData.product.price.blank }"
                                            :readonly="jobState === $Constants.JOB_STATUS_PENDING"
                                            @keypress="$AppUtility.inputOnlyNumber($event)"
                                            @change="getAdditionalPrice()"
                                            maxlength="6" />
                                    </div>
                                    <div class="input-error-message" v-if="errorData.product.price.blank">โปรดระบุราคาสินค้า</div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </perfect-scrollbar>

            <div class="text-center mt-4" v-if="jobState === $Constants.JOB_STATUS_NEW">
                <button class="btn btn-main" @click="openModalProduct()" v-if="isClaimSameProduct">เลือกสินค้าอื่น</button>
                <button class="btn btn-red" @click="claimSameProduct()" v-if="!isClaimSameProduct">เลือกสินค้าเดียวกับที่ซื้อ</button>
            </div>

            <div class="row">
                <div class="col-12">
                    <div class="field">
                        <label>สาเหตุการขอเคลม</label>
                        <input type="text"
                            v-model="formData.product.cause"
                            class="input-field"
                            :class="{ 'invalid': errorData.cause.blank }"
                            placeholder="ระบุสาเหตุการขอเคลม" />
                        <div class="input-error-message" v-if="errorData.cause.blank">โปรดระบุสาเหตุ</div>
                    </div>
                </div>
            </div>

            <div class="dashed-line mt-4 mb-3"></div>

            <div class="row">
                <div class="col-12 col-sm-6">
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="field text-right">
                        <label class="mt-2">จำนวนเงินที่ต้องชำระเพิ่ม</label>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3">
                    <div class="field">
                        <div class="input-price">
                            <input type="tel"
                                v-model="formData.product.additionalPrice"
                                class="input-field text-right"
                                readonly />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <job-modal-product
            :isDisplay="isShowModalProduct"
            @hide="closeModalProduct()"
            @addProduct="addProduct($event)"
            :isShowQuantity="false">
        </job-modal-product>
    </div>
</template>

<script>
import Helper from '@/resources/Helper';
import MixinThemeBoard from '@/theme/script/Board';
import JobModalProduct from '@/components/job/shared/ModalProduct';
import DBStock from '@/database/Stock';

export default {
    mixins: [ MixinThemeBoard ],
    components: {
        JobModalProduct
    },
    data() {
        return {
            isShowModalProduct: false,
            isClaimSameProduct: true,
            claimData: null,
            formData: null,
            displayData: null,
            selectedDot: null,
            optionDot: [],
            appHelper: Helper
        }
    },
    props: {
        jobState: Number,
        loadData: Object,
        errorData: Object
    },
    async mounted() {
        this.pageLoad();
    },
    methods: {
        async pageLoad() {
            this.formData = await this.initForm();
            this.getAdditionalPrice();
            this.$emit('formData', this.formData);

            this.setupDisplayData();
        },
        async bindClaimData(claimData) {
            if (claimData) {
                this.claimData = claimData;
                await this.setupDotOption(this.claimData.purchaseItem.inventoryKey);

                this.formData.product.return = this.setupClaimProductField(false);
                this.formData.product.replace = this.setupClaimProductField(true);
                
                this.getAdditionalPrice();
            }

            this.setupDisplayData();
        },
        async claimSameProduct() {
            await this.setupDotOption(this.claimData.purchaseItem.inventoryKey);

            this.formData.product.replace = this.setupClaimProductField(true);
            this.isClaimSameProduct = true;

            this.getAdditionalPrice();
            this.setupDisplayData();
        },
        async setupDotOption(inventoryKey) {
            const stock = await DBStock.getDetail(inventoryKey);

            this.optionDot = DBStock.generateDotOption(stock.dots, 'ระบุเอง');
        },
        setupDisplayData() {
            this.displayData = {
                return: {
                    sku: this.formData.product.return.sku ? this.formData.product.return.sku : '',
                    productName: this.formData.product.return.productData ? this.formData.product.return.productData.name : '',
                    dot: this.formData.product.return.dot,
                    purchasePrice: this.formData.product.return.price,
                    productCategory: this.formData.product.return.productData ? this.formData.product.return.productData.productCategory : ''
                },
                replace: {
                    sku: this.formData.product.replace ? this.formData.product.replace.sku : '',
                    productName: this.formData.product.replace.productData ? this.formData.product.replace.productData.name : '',
                    productCategory: this.formData.product.replace.productData ? this.formData.product.replace.productData.productCategory : ''
                }
            };
        },
        async initForm() {
            this.selectedDot = {
                value: '',
                isLoadData: false
            };

            if (this.loadData) {
                await this.setupDotOption(this.loadData.product.replace.inventoryKey);

                const optionIndex = this.optionDot.findIndex(x => x.id === this.loadData.product.replace.dot);

                this.selectedDot['value'] = optionIndex > -1 ? this.loadData.product.replace.dot : '-';
                this.selectedDot['isLoadData'] = true;
            }

            return {
                product: {
                    return: this.loadData ? this.loadData.product.return : this.setupClaimProductField(false),
                    replace: this.loadData ? this.loadData.product.replace : this.setupClaimProductField(true),
                    cause: this.loadData ? this.loadData.product.cause : '',
                    additionalPrice: this.loadData ? this.loadData.product.priceDifferent : 0
                }
            };
        },
        changeSelectedDot(value) {
            if (!this.selectedDot.isLoadData) {
                this.formData.product.replace.dot = value === '-' ? '' : value;
            }

            this.selectedDot.isLoadData = false;
        },
        setupClaimProductField(isReplaceItem) {
            const data = this.claimData;

            return {
                productData: data ? data.purchaseItem.productData : null,
                inventoryKey: data ? data.purchaseItem.inventoryKey : '',
                sku: data ? data.purchaseItem.inventoryData.sku : null,
                dot: data && !isReplaceItem ? data.purchaseItem.input.dot : '',
                price: data ? data.purchaseItem.input.price : ''
            }
        },
        getAdditionalPrice() {
            const replacePrice = this.formData.product.replace.price ? this.formData.product.replace.price : 0;
            const returnPrice = this.formData.product.return.price ? this.formData.product.return.price : 0;
            const additionalPrice = replacePrice - returnPrice;

            this.formData.product.additionalPrice = additionalPrice < 0 ? 0 : additionalPrice;
        },
        openModalProduct() {
            this.isShowModalProduct = true;
        },
        closeModalProduct() {
            this.isShowModalProduct = false;
        },
        async addProduct(data) {
            this.formData.product.replace = this.mapTableData(data);
            this.isClaimSameProduct = false;

            await this.setupDotOption(this.formData.product.replace.inventoryKey);

            this.setupDisplayData();
            this.getAdditionalPrice();
            this.closeModalProduct();
        },
        mapTableData(data) {
            return {
                productData: data.productData,
                inventoryKey: data.inventoryKey,
                sku: data.inventoryData.sku,
                dot: '',
                price: data.inventoryData.price
            };
        }
    }
}
</script>

<style lang="scss" scoped>
table {
    td {
        &.column-small {
            width: 180px;
        }

        .input-field {
            font-size: 14px;
        }
    }
}
</style>